<template>
    <div class="page-view">
        <tab-group></tab-group>
        <div class="section-wrapper">
            <div class="content-section clearfix">
                <!-- 部门架构 -->
                <div class="content-section__item content-section__left">
                    <div class="conent-header">部门架构</div>
                    <div class="conent-body">
                        <div class="item-header">
                            <el-input class="search-input" clearable placeholder v-model="filterOrganization">
                                <el-button
                                        @click="handleFilterData('filterOrganizationTree', filterOrganization)"
                                        slot="append"
                                        icon="e6-icon-search_line"
                                ></el-button>
                            </el-input>
                        </div>
                        <div class="item-body">
                            <el-tree
                                    ref="filterOrganizationTree"
                                    show-checkbox
                                    default-expand-all
                                    node-key="id"
                                    :data="organizations"
                                    :check-strictly="true"
                                    :highlight-current="true"
                                    :expand-on-click-node="false"
                                    @check-change="handleCheckChange"
                                    @node-click="handleNodeClick"
                                    :filter-node-method="filterNode"
                            ></el-tree>
                        </div>
                    </div>
                </div>
                <!-- 部门架构 end -->
                <!-- 部门子集架构 -->
                <div class="content-section__item content-section__middle">
                    <div class="conent-header"></div>
                    <div class="conent-body">
                        <div class="item-header">
                            <el-input class="search-input" clearable placeholder v-model="filterSubOrganization">
                                <el-button
                                        @click="handleFilterData('filterSubOrganizationTree', filterSubOrganization)"
                                        slot="append"
                                        icon="e6-icon-search_line"
                                ></el-button>
                            </el-input>
                        </div>
                        <div class="item-body">
                            <el-tree
                                    ref="filterSubOrganizationTree"
                                    default-expand-all
                                    :data="subOrganizations"
                                    :check-strictly="true"
                                    :highlight-current="true"
                                    :expand-on-click-node="false"
                                    @node-click="handleSubNodeClick"
                                    :filter-node-method="filterNode"
                            >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span v-if="data.id">部门--{{ data.label }}</span>
                  <span v-if="data.dataId">用户--{{ node.label }}</span>
                </span>
                            </el-tree>
                        </div>
                    </div>
                </div>
                <!-- 部门子集架构 end -->
                <!-- 用户信息 -->
                <div class="content-section__item content-section__right">
                    <div class="conent-header">用户信息</div>
                    <div class="conent-body">
                        <div class="form-wrapper">
                            <e6-form-extend
                                    ref="formExtend"
                                    :formExtend="formExtend"
                                    :inline="true"
                                    label-width="120px"
                            >
                                <template slot-scope="slotForms">
                                    <el-form-item
                                            prop="forms.orgId"
                                            label="所属部门"
                                            :rules="[
                      { required: true, message: '请输入所属部门', trigger: 'blur' }
                    ]"
                                    >
                                        <!-- <el-input v-model="slotForms.forms.orgId" placeholder="所属部门" clearable></el-input> -->
                                        <e6-select-pri
                                                @hide="handleHide"
                                                ref="selectTree"
                                                :data="organizations"
                                                :filter="false"
                                                :multiple="false"
                                                placeholder="所属部门"
                                                :disabled="parentDepartmentDisabled"
                                        ></e6-select-pri>
                                    </el-form-item>
                                    <el-form-item prop="forms.userName" label="用户名称">
                                        <el-input
                                                disabled
                                                v-model="slotForms.forms.userName"
                                                placeholder="用户名称"
                                                clearable
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item prop="forms.userCode" label="登录名">
                                        <el-input
                                                disabled
                                                v-model="slotForms.forms.userCode"
                                                placeholder="登录名"
                                                clearable
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item prop="forms.phone" label="联系电话">
                                        <el-input disabled v-model="slotForms.forms.phone" placeholder="联系电话" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item prop="forms.roleName" label="角色">
                                        <el-input
                                                disabled
                                                v-model="slotForms.forms.roleName"
                                                placeholder="角色"
                                                clearable
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </e6-form-extend>
                        </div>
                    </div>
                </div>
                <!-- 用户信息 end -->
            </div>
            <div class="operate-section">
                <el-button type="primary" @click="handleSubmitForm">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        FetchFindOrganizationAndUserTreeByOrgId,
        FetchFindOrganizationAndUserVOByUserId,
        FetchUpdateUserOrgId
    } from "_private/api/systemSetting/organizationManage";
    import {mapGetters, mapActions} from "vuex";
    import {objUpdate} from "_private/utils/merge";
    import TabGroup from "./tabGroup";

    export default {
        components: {
            TabGroup
        },
        data() {
            return {
                filterOrganization: "",
                filterSubOrganization: "",
                subOrganizations: [],
                editCheckId: "",
                editSubCheckId: "",
                formExtend: {
                    forms: {
                        orgId: "",
                        userName: "",
                        userCode: "",
                        phone: "",
                        roleName: ""
                    }
                },
                parentDepartmentDisabled: true
            };
        },
        computed: {
            ...mapGetters(["organizations"])
        },
        watch: {
            filterOrganization(val) {
                if (this.filterOrganization === "") {
                    this.$refs.filterOrganizationTree.filter(val);
                }
            },
            filterSubOrganization(val) {
                if (this.filterSubOrganization === "") {
                    this.$refs.filterSubOrganizationTree.filter(val);
                }
            }
        },
        created() {
            this.setOrganizationAct();
        },
        methods: {
            ...mapActions(["setOrganizationAct"]),
            // 根据ordId获取子集部门
            FetchFindOrganizationAndUserTreeByOrgId(data) {
                FetchFindOrganizationAndUserTreeByOrgId(data)
                    .then(response => {
                        if (
                            response.result &&
                            Array.isArray(response.result) &&
                            response.result.length > 0
                        ) {
                            this.subOrganizations = response.result;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            // 获取用户信息
            FetchFindOrganizationAndUserVOByUserId(data) {
                FetchFindOrganizationAndUserVOByUserId(data)
                    .then(response => {
                        if (response.result) {
                            this.setOrgId(response.result.orgId);
                            objUpdate(this.formExtend.forms, response.result);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            // 修改用户信息
            FetchUpdateUserOrgId(data) {
                FetchUpdateUserOrgId(data)
                    .then(response => {
                        this.submitCallback(response);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            // 提交以后的回调函数
            submitCallback(data) {
                let type = data.code === 1 ? "success" : "error";
                let message = data.message;
                this.$message({
                    showClose: true,
                    message: message,
                    type: type,
                    duration: 1500,
                    onClose: () => {
                        if (type === "success") {
                            this.setOrganizationAct();
                            this.cancelOrganization();
                        }
                    }
                });
            },
            // 获取选中的部门 id
            getCheckedNodes() {
                let orgIds = this.$refs.filterOrganizationTree.getCheckedNodes();
                return orgIds.length < 1 ? "" : orgIds[0].id;
            },
            // 清除部门数据
            cancelOrganization() {
                this.$refs.filterOrganizationTree.setCheckedKeys([]);
            },
            // 清除子集部门数据
            cancelSubOrganization() {
                this.editSubCheckId = "";
            },
            // 清楚用户信息
            cancelUserInfo() {
                this.$refs.formExtend.resetForm();
            },
            // 过滤部门方法
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            // 筛选数据
            handleFilterData(ref, data) {
                this.$refs[ref].filter(data);
            },
            // 选择部门
            handleCheckChange(item, node) {
                if (node === true) {
                    //点击未选中复选框
                    this.editCheckId = item.id;
                    this.$refs.filterOrganizationTree.setCheckedKeys([item.id]);
                    this.FetchFindOrganizationAndUserTreeByOrgId({orgId: item.id});
                } else {
                    if (this.editCheckId === item.id) {
                        // 清楚部门架构选择
                        this.cancelOrganization();
                        // 清除子集部门数据
                        this.subOrganizations = [];
                        // 清除子集部门id
                        this.cancelSubOrganization();
                        // 清除用户信息
                        this.cancelUserInfo();
                    }
                }
                this.$refs.selectTree.resetChecked();
            },
            handleNodeClick(item) {
                this.editCheckId = item.id;
                this.$refs.filterOrganizationTree.setCheckedKeys([item.id]);
                this.FetchFindOrganizationAndUserTreeByOrgId({orgId: item.id});
            },
            // 选择子集部门
            handleSubNodeClick(item) {
                // 点击非用户结点清楚数据
                // 清除子集部门id
                this.editSubCheckId = "";
                // 清楚用户信息
                this.cancelUserInfo();
                this.$refs.selectTree.resetChecked();
                this.parentDepartmentDisabled = true;
                if (item.dataId) {
                    this.parentDepartmentDisabled = false;
                    this.editSubCheckId = item.dataId;
                    this.FetchFindOrganizationAndUserVOByUserId({dataId: item.dataId});
                }
            },
            // 设置部门id
            setOrgId(data) {
                if (data) {
                    this.$refs.selectTree.setCheckedKeys([data]);
                }
            },
            // 获取部门id
            getOrgId() {
                let selected = this.$refs.selectTree.getCheckedNodes();
                selected = selected.map(item => {
                    return item.id;
                });
                return selected.length ? selected.join(",") : "";
            },
            handleHide() {
                this.formExtend.forms.orgId = this.getOrgId();
            },
            // 提交数据
            handleSubmitForm() {
                // 未选择部门
                if (!this.getCheckedNodes()) {
                    this.$message({
                        showClose: true,
                        message: "请选择一个部门",
                        type: "error",
                        duration: 1200
                    });
                    return;
                }
                // 未选择用户
                if (!this.editSubCheckId) {
                    this.$message({
                        showClose: true,
                        message: "请选择一个用户",
                        type: "error",
                        duration: 1200
                    });
                    return;
                }
                // 未选择部门
                if (!this.formExtend.forms.orgId) {
                    this.$message({
                        showClose: true,
                        message: "请选择所属部门",
                        type: "error",
                        duration: 1200
                    });
                    return;
                }
                this.$refs.formExtend.submitForm().then(valid => {
                    if (valid) {
                        this.FetchUpdateUserOrgId({
                            userId: this.editSubCheckId,
                            orgId: this.formExtend.forms.orgId
                        });
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .page-view {
        height: 100%;
    }

    .section-wrapper {
        height: calc(100% - 61px);
        padding: 0 20px;
    }

    .content-section {
        height: calc(100% - 58px);
        .content-section__item {
            height: 100%;
            float: left;
            .conent-header {
                height: 50px;
                font-size: 16px;
                line-height: 50px;
            }
            .conent-body {
                height: calc(100% - 50px - 20px);
                min-height: 52px;
                border: 1px solid #ccc;
                box-sizing: border-box;
            }
        }
        .content-section__middle,
        .content-section__left {
            width: calc(35% - 50px);
            margin-right: 50px;
            .item-header {
                display: flex;
                align-items: center;
                position: relative;
                height: 50px;
                border-bottom: 1px solid #ccc;
                .search-input {
                    position: absolute;
                    left: 10px;
                    top: 50%;
                    width: 200px;
                    margin-top: -14px;
                }
            }
            .item-body {
                height: calc(100% - 51px);
                overflow: auto;
            }
        }
        .content-section__right {
            width: 30%;
            height: 100%;
            overflow: auto;
            .conent-body {
                overflow: auto;
            }
            .form-wrapper {
                padding-top: 15px;
            }
        }
    }

    .operate-section {
        position: relative;
        background-color: #fff;
        text-align: center;
        .el-button {
            margin: 15px 0;
        }
    }
</style>
